import {
    AfterContentChecked,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { PROGRESS_NAME } from '../../../../ui/shared/ui/vg-progress/vg-progress.component';
import { setProgressAction } from '../../../../data/current-progress/store/current-progress.actions';
import { Store } from '@ngrx/store';
import { GetPurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/get-purchase-persistence.usecase';
import { SetDataLayerParamsUseCase } from '@/core/domain/gtm/usecases/setDataLayer.usecase';
import { Router } from '@angular/router';
import { GtmCheckOut } from '@/core/domain/gtm/models/gtm-check-out.models';
import { GtmPageView } from '@/core/domain/gtm/models/gtm-page-view.models';
import { CardDesign } from '@/core/domain/configurations/models/configurations.model';
import { PurchasePersistenceModel } from '@/core/domain/purchase-persistence/models/PurchasePersistence.model';
import { BehaviorSubject, EMPTY, of, switchMap } from 'rxjs';
import { UrlService } from '@/common/url/url.service';
import { CheckLoginUseCase } from '@/core/domain/auth/usecases/check-login.usecase';
import { UserDetails } from '@/data/auth/services/ezy/responses/interfaces/user-details.interface';
import { selectAuthValue } from '@/data/auth/store/auth.selectors';

@Component({
    selector: 'vg-custom',
    templateUrl: './custom.component.html',
    styleUrls: ['./custom.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CustomComponent implements AfterViewInit, AfterContentChecked {
    public cardDesign$ = new BehaviorSubject<CardDesign | null>(null);

    public purchasePersistence: PurchasePersistenceModel | null = null;

    public currentImage = '';
    public isUserLogged = false;

    public onSelectedCard(cardDesign: CardDesign): void {
        this.cardDesign$.next(cardDesign);
    }

    constructor(
        // eslint-disable-next-line @ngrx/no-typed-global-store
        private readonly store: Store<{
            currentProgress: PROGRESS_NAME;
        }>,
        private readonly authCheckLogin: CheckLoginUseCase,
        private readonly cdref: ChangeDetectorRef,
        private readonly getPurchasePersistence: GetPurchaseUseCase,
        private readonly gtmDataLayer: SetDataLayerParamsUseCase,
        private readonly router: Router,
        private readonly url: UrlService,
    ) {
        this.store.dispatch(setProgressAction({ value: 'personalization' }));
        this.initPurchasePersistence();
    }
    ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }
    ngAfterViewInit(): void {
        const prevButton = document.querySelector(
            '.swiper-button-prev-outside',
        );
        const nextButton = document.querySelector(
            '.swiper-button-next-outside',
        );

        prevButton?.addEventListener('click', () => {
            // this.changeImageSwipper();
        });

        nextButton?.addEventListener('click', () => {
            // this.changeImageSwipper();
        });

        this.authCheckLogin
            .execute()
            .pipe(
                switchMap((auth) => {
                    if (auth) {
                        this.isUserLogged = true;
                    }
                    return of(null);
                }),
            )
            .subscribe();
        this.gtmPageView();
    }

    changeImageSwipper() {
        const currentImgSwipper = document.querySelector<HTMLImageElement>(
            '.swiper-slide-active img',
        );
        const currentImg = document.querySelector<HTMLImageElement>(
            '.container-card-price img',
        );

        if (currentImgSwipper && currentImg) {
            currentImg.style.opacity = '0.5';

            setTimeout(function () {
                if (currentImgSwipper && currentImg) {
                    currentImg.src = currentImgSwipper.src;
                }
            }, 400);

            setTimeout(function () {
                if (currentImgSwipper && currentImg) {
                    currentImg.style.opacity = '1';
                }
            }, 600);
        }
    }

    gtmPageView() {
        this.gtmDataLayer.execute<GtmPageView>({
            event: 'ev_pageview',
            page_path: this.router.url,
            page_title: 'custom',
        });
    }

    public initPurchasePersistence(): void {
        this.getPurchasePersistence
            .execute()
            .subscribe((purchasePersistence) => {
                this.purchasePersistence = purchasePersistence;
                this.initGetInfoUser();
            });
    }

    private initGetInfoUser(): void {
        this.store
            .select(selectAuthValue)
            .pipe(
                switchMap(() => {
                    return this.authCheckLogin.execute();
                }),
                switchMap((auth) => {
                    if (auth) {
                        this.onGetInfoUserValidateEmail(auth.details);
                    }
                    return of(EMPTY);
                }),
            )
            .subscribe();
    }

    private onGetInfoUserValidateEmail(userInfo: UserDetails): void {
        if (
            this.purchasePersistence?.shipment?.scheduleShipping === true &&
            this.purchasePersistence.shipment?.recipientEmail === userInfo.email
        ) {
            this.url
                .format('purchase/send')
                .subscribe((url) => this.router.navigateByUrl(url));
        }
    }
}
